<template>
	<div class="login">
		<div class="text-xs-center">
			<img src="@Assets/images/logo-careyes.png" alt="CareYes">

			<div class="form">
				<h2>Por favor, faça login na sua conta.</h2>

				<v-text-field v-model="user.usuario" v-validate="{ required: true }" label="Usuário"
					placeholder="Seu usuário" data-vv-name="usuario" :error-messages="errors.collect('usuario')"
					@keydown.enter="doLogin" />

				<v-text-field v-model="user.senha" v-validate="{ required: true, min: 6 }" label="Senha" placeholder="*******"
					data-vv-name="senha" type="password" :error-messages="errors.collect('senha')"
					@keydown.enter="doLogin" />
				<v-btn depressed round block :loading="carregando" :disabled="carregando"
					class="btn-login"
					@click="doLogin">
					Entrar no CareYes
				</v-btn>
				<v-btn v-if="false" depressed round block class="esqueceu-senha">
					Esqueceu a senha?
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import { TOKEN } from '@Consts/strings';
import UsuarioPresenter from '@Presenter/usuario-presenter';
// import { fetchToken } from '@Config/firebase';
// import NotificacaoTokenPresenter from '@Presenter/notificacao-token-presenter';

export default {
  name: 'LoginForm',
  $_veeValidate: { validator: 'new' },
  data: () => ({
    carregando: false,
    user: {}
  }),
  methods: {
    async doLogin() {
      if (this.carregando) return;
      const is_valid = await this.$validator.validate();
      if (!is_valid) {
        this.$store.dispatch('SHOW_SNACKBAR', { color: 'error', message: this.errors.all()[0] });
        return;
      }
      this.carregando = true;
      UsuarioPresenter.loginUsuario({ ...this.user })
        .then(resp => {
          let nao_retornar_perm = {};
          switch (resp.configuracoes.permissao) {
            case 'paciente':
              nao_retornar_perm = {
                instituicao: {
                  dados_bancarios: true,
                  financeiroInfo: true
                },
                profissional: true
              };
              break;
            case 'funcionario':
              nao_retornar_perm = {
                instituicao: {
                  dados_bancarios: true,
                  financeiroInfo: true
                },
                paciente: true
              };
              break;
            default:
              nao_retornar_perm = {
                paciente: true
              };
              break;
          }

          UsuarioPresenter.contextoToken({
            token: resp.access_token.token,
            nao_retornar: nao_retornar_perm
          })
            .then(async response => {
              this.$store.dispatch('CONTEXTO', response.contexto);
              localStorage.setItem(TOKEN, resp.access_token.token);
              if (response.contexto.paciente)
                this.$router.push({ name: 'Notas' });
              else if (response.contexto.configuracoes && this.$functions.hasAnyPermissions(['funcionario'])) this.$router.push({ name: 'ProfissionalWeb' });
              else if (response.contexto.tipo === 'ceo' && this.$functions.hasAnyPermissions(['superAdministrador'])) this.$router.push({ name: 'Instituições' });
              else
                this.$router.push({ name: 'Inicio' });
            });
        })
        .finally(() => {
          this.carregando = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@Assets/css/settings.scss";

.login {
  display: flex;
  padding: 50px;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media screen and (min-width: $break-point-md) {
    padding: 25px;
  }

  div {
    max-width: 350px;

    img {
      width: 100%;
      max-width: 180px;
    }

    .form {
      margin: 50px 0 0;
      text-align: left;

      @media screen and (min-width: $break-point-md) {
        margin: 100px 0 0;
      }

      h2 {
        font-size: 17px;
        margin-bottom: 35px;
      }

      .btn-login {
        background: $cy-gradient-extra-strong;
        color: #fff;
        margin: 20px 0 0;
        text-transform: none;
        font-size: 15px;
        height: 40px;
        font-weight: bold;
      }

      .esqueceu-senha {
        background: transparent;
        color: $border-color;
        margin-top: 15px;
        text-transform: none;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}
</style>
